var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54963 1.17122C1.62147 0.874689 1.87982 0.666468 2.17647 0.666016H8H13.8235C14.1202 0.666468 14.3785 0.874689 14.4504 1.17122L14.4516 1.17253L15.7445 6.50195C15.7578 6.55556 15.7646 6.61067 15.7647 6.66602C15.7647 7.0342 15.475 7.33268 15.1176 7.33268V13.9993C15.1176 14.7281 14.5308 15.3327 13.8235 15.3327H2.17647C1.46919 15.3327 0.88235 14.7281 0.88235 13.9993V7.33268C0.524989 7.33268 0.235291 7.0342 0.235291 6.66602C0.235396 6.61067 0.242188 6.55556 0.255512 6.50195L1.54205 1.19987C1.54397 1.19071 1.54607 1.18159 1.54837 1.17253L1.54963 1.17122ZM11.8824 7.33268L8.00004 3.33268L4.11769 7.33268H2.17651V13.9993H6.70592V10.666C6.70592 9.92935 7.28504 9.33268 8.00004 9.33268C8.71504 9.33268 9.29416 9.92935 9.29416 10.666V13.9993H13.8236V7.33268H11.8824ZM3.4706 9.33268V11.3327H5.41177V9.33268H3.4706ZM10.5882 11.3327V9.33268H12.5294V11.3327H10.5882Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2b19da23fb061d766377cd4d2c1b73c9.svg";
export { ForwardRef as ReactComponent };